/**问卷状态 */
const SurveyStatus = {
    CREATED: { value: 1, desc: '新建' },
    DISPENSED: { value: 2, desc: '已发布' },
    PAUSED: { value: 3, desc: '暂停' },
    END: { value: 4, desc: '终止' },
    FINISHED: { value: 5, desc: '已完成'},
    ANSWERED: { value: 6, desc: '作答过'},
    NO_PERMISSION: { value: 7, desc: '无权限' },
    FULL: { value: 10, desc: '已达作答上限' }
}

/**作答状态 */
const AnswerStatus = {
    TO_AUDIT: { value: 1, desc: '待审核' },
    SIMULATED: { value: 2, desc: '模拟' },
    ACCEPTED: { value: 3, desc: '已采纳' },
    IGNORED: { value: 4, desc: '忽略' },
    MANUAL_REJECT: { value: 5, desc: '手动拒绝' },
    AUTO_REJECT: { value: 6, desc: '自动拒绝' }
}

const PageTemplateEnum = {
    HOME: 1,
    SAMPLE: 2
}

const BlockEnum = {
    HOT_FUNC: 1,
    REASEARCH_PRO: 2,
    LIGHT_SPOT: 3,
    ACTIVITY_INFO: 4,
    CONTACT_US: 5,
    TITLE_BTN: 6,
    NEWS: 7,
    RESOURCE: 8,
    CUSTOM: 9
}

export {
    SurveyStatus,
    AnswerStatus,
    PageTemplateEnum,
    BlockEnum
}



// WEBPACK FOOTER //
// ./src/config/enum.js